// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../../../../types';
import media from '../../../../../../../helpers/media';
import type { ColorTileProps } from '../../../types';

type Props = ColorTileProps;

export default styled<any, Theme, Props>('div')`
  font-size: ${props => props.theme.configColor.tile.fontSize};
  width: 1em;
  height: 1em;
  background: ${props => props.color};
  ${props => props.twoToneColor && css`
    background-image: linear-gradient(-45deg, ${props.twoToneColor} 50%, transparent 51%);
  `};
  background-origin: border-box;
  border-radius: ${props => props.theme.configColor.tile.borderRadius};
  border: 3px solid transparent;
  box-sizing: border-box;

  ${media.md(css`
    font-size: 3.5rem;
    border-width: 4px;
  `)};

  ${props => props.active && css`
    border-color: ${props.theme.configColor.tile.borderColor};
  `}
`;
